(function () {
  'use strict';

  var EXCLUDED_CLASS = 'free-shipping-excluded';
  var EXCLUDED_TEMPLATES = ['pack', 'teamatical'];
  var EXCLUDED_TYPES = ['pack', 'teamatical'];
  var EXCLUDED_VENDORS = ['teamatical'];
  var EXCLUDED_TAGS = ['ballpack', 'pack', 'teamatical'];

  var cache = {};
  var pending = {};
  var evaluationToken = 0;

  function normalize(value) {
    return value == null ? '' : String(value).trim().toLowerCase();
  }

  function isListed(value, list) {
    return list.indexOf(normalize(value)) !== -1;
  }

  function isExcludedLineItem(item) {
    if (!item) return false;
    return isListed(item.vendor, EXCLUDED_VENDORS) || isListed(item.product_type, EXCLUDED_TYPES);
  }

  function isExcludedProduct(product) {
    if (!product) return false;
    if (isListed(product.template_suffix, EXCLUDED_TEMPLATES)) return true;
    if (isListed(product.vendor, EXCLUDED_VENDORS)) return true;
    if (isListed(product.type, EXCLUDED_TYPES)) return true;

    var tags = Array.isArray(product.tags) ? product.tags : [];
    for (var i = 0; i < tags.length; i++) {
      if (isListed(tags[i], EXCLUDED_TAGS)) return true;
    }
    return false;
  }

  function loadProduct(handle) {
    if (Object.prototype.hasOwnProperty.call(cache, handle)) {
      return Promise.resolve(cache[handle]);
    }
    if (pending[handle]) {
      return pending[handle];
    }

    pending[handle] = fetch('/products/' + encodeURIComponent(handle) + '?view=ig-ajax')
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .catch(function () {
        return null;
      })
      .then(function (product) {
        cache[handle] = product;
        delete pending[handle];
        return product;
      });

    return pending[handle];
  }

  function getLineItems() {
    var cart = window.$Cart;
    if (!cart || !cart.state || !Array.isArray(cart.state.items)) return [];
    return cart.state.items
      .map(function (item) {
        return item.state;
      })
      .filter(Boolean);
  }

  function setExcluded(isExcluded) {
    var root = document.getElementById('ModalCart');
    if (!root) return;
    root.classList.toggle(EXCLUDED_CLASS, isExcluded);
  }

  function evaluate() {
    var items = getLineItems();
    var token = ++evaluationToken;

    if (items.length === 0) {
      setExcluded(false);
      return;
    }

    if (items.some(isExcludedLineItem)) {
      setExcluded(true);
      return;
    }

    var handles = [];
    items.forEach(function (item) {
      if (item.handle && handles.indexOf(item.handle) === -1) {
        handles.push(item.handle);
      }
    });

    Promise.all(handles.map(loadProduct)).then(function (products) {
      if (token !== evaluationToken) return;
      setExcluded(products.some(isExcludedProduct));
    });
  }

  window.addEventListener('innovate::cartChanged', evaluate);
  window.addEventListener('innovate::cartLineItemAdded', evaluate);
  window.addEventListener('innovate::cartLineItemChanged', evaluate);
  window.addEventListener('innovate::cartDrawerOpened', evaluate);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', evaluate);
  } else {
    evaluate();
  }
})();
